
import React from "react";
export default function CTA() {
  return (
    <section id="cta" className="bg-gradient-to-r from-brand-600 to-brand-700 text-white">
      <div className="max-w-7xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-8 items-center">
        <div className="reveal">
          <h2 className="text-2xl md:text-3xl font-bold">Get your AI Career Roadmap</h2>
          <p className="mt-2 opacity-90">We’ll assess your goals and send a step‑by‑step plan with timelines.</p>
          <form className="mt-6 grid sm:grid-cols-2 gap-3" onSubmit={e => e.preventDefault()}>
            <input className="input text-slate-900" type="text" name="name" placeholder="Your name" required />
            <input className="input text-slate-900" type="email" name="email" placeholder="Email" required />
            <input className="input text-slate-900 sm:col-span-2" type="text" name="goal" placeholder="Your career goal (e.g., AI Engineer)" />
            <button className="sm:col-span-2 px-5 py-3 rounded-lg bg-white text-brand-700 font-semibold hover:bg-slate-100">Request Plan</button>
          </form>
        </div>
        <div className="rounded-xl bg-white/10 p-6 reveal">
          <p className="text-sm opacity-90">
            Includes: skills map, project list, mentor schedule & interview prep.
          </p>
        </div>
      </div>
    </section>
  );
}
